module.exports = __webpack_public_path__ + "assets/img/case1.dfe044c7.png";